export const estimateLandingPage = {
  // META
  'estimate_landing_page.meta.title': 'Odhad ceny nemovitosti online',
  'estimate_landing_page.meta.description':
    'Jak zjistit hodnotu nemovitosti online? ✅  Získejte odhad ceny. ✅  Zdarma a bez zadávání osobních údajů.',
  'estimate_landing_page.meta.og_title': 'Odhad nemovitosti zdarma',
  'estimate_landing_page.meta.og_description':
    'Zjistěte cenu nemovitosti online',

  // section 1
  'estimate_landing_page.section_one.title':
    'Zjistěte cenu <br /> nemovitosti online',
  'estimate_landing_page.section_one.info_1': 'Zdarma, z pohodlí domova',
  'estimate_landing_page.section_one.info_2': 'Do tří minut máte jasno',
  'estimate_landing_page.section_one.info_3':
    'Můžete sledovat vývoj ceny své nemovitosti',
  'estimate_landing_page.section_one.cta.want_estimate':
    'Spočítat odhad ZDARMA',

  // section 2
  'estimate_landing_page.section_two.title':
    'Jsme nejvíce hodnocenou realitní společností na Českém trhu',
  'estimate_landing_page.section_two.review':
    'Hodnoceno <b>4.7/5</b> z <b>1021</b> recenzentů',

  // section 3
  'estimate_landing_page.section_three.title': 'Proč odhadovat s námi?',
  'estimate_landing_page.section_three.item.title':
    'Nejoblíbenější online odhad',
  'estimate_landing_page.section_three.item.content':
    'Už 208 364 majitelů si s námi ocenilo svou nemovitost a pravidelně sledují vývoj její ceny.',
  'estimate_landing_page.section_three.item_2.title':
    'Desítky hodnocených faktorů',
  'estimate_landing_page.section_three.item_2.content':
    'Při výpočtu odhadu ceny u nemovitosti zohledníme nejvyšší množství relevantních faktorů.',
  'estimate_landing_page.section_three.item_3.title': 'Vysoká jistota odhadu',
  'estimate_landing_page.section_three.item_3.content':
    'Využíváme přesná data z katastru nemovitostí a realitních trendů 2022.',
  'estimate_landing_page.section_three.item_4.title': 'Neustálý přehled o ceně',
  'estimate_landing_page.section_three.item_4.content':
    'Můžete sledovat vývoj ceny své nemovitosti, aktualizovaný vždy podle nových dat z katastru.',

  // section 4
  'estimate_landing_page.section_four.write_about_us.title': 'Napsali o nás:',

  // section 5
  'estimate_landing_page.section_five.title': 'Získejte ocenění online',
  'estimate_landing_page.section_five.item.title':
    'Zadáte údaje o vaší nemovitosti',
  'estimate_landing_page.section_five.item_2.title':
    'Umělá inteligence spočítá cenu',
  'estimate_landing_page.section_five.item_3.title':
    'Cenový odhad dostanete ihned',
  'estimate_landing_page.section_five.cta.want_estimate':
    'Spočítat odhad ZDARMA',

  // section 6
  'estimate_landing_page.section_six.title':
    'Co říkají majitelé, kteří si udělali online odhad?',
  'estimate_landing_page.section_six.item.fullname': 'Miloš Zlesa',
  'estimate_landing_page.section_six.item.date': 'Před 2 dny',
  'estimate_landing_page.section_six.item.message':
    'Pravděpodobně nejlepší odhad ceny nemovitosti na českém internetu! Vyplňujete i počet místností, stav bytu i kuchyně nebo koupelny. Ukáže vám to i prodané byty v okolí. Skvěle je i pravidelné informování o změnách cen. Doporučuji!',
  'estimate_landing_page.section_six.item_2.fullname': 'Milan Rada',
  'estimate_landing_page.section_six.item_2.date': '26. října 2022',
  'estimate_landing_page.section_six.item_2.message':
    'Reas.cz poskytuje nejobjektivnější zpracování odhadů nemovitostí. Odhady vycházejí z průběžného sledování vývoje na trhu s nemovitostmi. Ve své činnosti nemá v ČR srovnatelnou konkurenci.',
  'estimate_landing_page.section_six.item_3.fullname': 'Viktor Piler',
  'estimate_landing_page.section_six.item_3.date': 'před 4 týdny',
  'estimate_landing_page.section_six.item_3.message':
    'Krásná práce. Po zadání několika základních údajů jsem dostal informaci o ceně nemovitosti!',
  'estimate_landing_page.section_six.item_4.fullname': 'Olga Navrátilová',
  'estimate_landing_page.section_six.item_4.date': '26. září 2022',
  'estimate_landing_page.section_six.item_4.message':
    'Je zajímavé sledovat s ohledem na stávající okolnosti vývoj ceny mého bytu. Jsem už v pokročilém věku a pomáhá mi to promyslet podíly pro dědice. Děkuji.',
  'estimate_landing_page.section_six.more': 'a více než 1000 dalších',

  // section 7
  'estimate_landing_page.section_seven.title':
    'Zjistěte cenu nemovitosti online',
  'estimate_landing_page.section_seven.cta.calc_estimate':
    'Spočítat odhad ZDARMA',

  // Page B

  // META
  'estimate_landing_page_b.meta.title': 'Odhad ceny nemovitosti online',
  'estimate_landing_page_b.meta.description':
    'Jak zjistit hodnotu nemovitosti online? ✅  Získejte odhad ceny. ✅  Zdarma a bez zadávání osobních údajů.',
  'estimate_landing_page_b.meta.og_title': 'Odhad nemovitosti zdarma',
  'estimate_landing_page_b.meta.og_description':
    'Zjistěte cenu nemovitosti online',

  // section 1
  'estimate_landing_page_b.section_one.title':
    'Zjistěte cenu <br/> nemovitosti online',
  'estimate_landing_page_b.section_one.info_1':
    'Ověřte si cenu nemovitosti <b>ZDARMA</b>',
  'estimate_landing_page_b.section_one.info_2': 'Do tří minut máte jasno',
  'estimate_landing_page_b.section_one.info_3':
    'Můžete sledovat vývoj ceny své nemovitosti',
  'estimate_landing_page_b.section_one.cta.want_estimate':
    'Spočítat odhad ZDARMA',

  // section 2
  'estimate_landing_page_b.section_two.title':
    'Vyzkoušejte nejoblíbenější online odhad v České republice',
  'estimate_landing_page_b.section_two.review':
    'Hodnoceno <b>4.7/5</b> z <b>1407</b> recenzentů',

  // section 3
  'estimate_landing_page_b.section_three.title': 'Proč odhadovat s námi?',
  'estimate_landing_page_b.section_three.item.title':
    'Nejoblíbenější online odhad',
  'estimate_landing_page_b.section_three.item.content':
    'Už 208 364 majitelů si s námi ocenilo svou nemovitost a pravidelně sledují vývoj její ceny.',
  'estimate_landing_page_b.section_three.item_2.title':
    'Desítky hodnocených faktorů',
  'estimate_landing_page_b.section_three.item_2.content':
    'Při výpočtu odhadu ceny u nemovitosti zohledníme nejvyšší množství relevantních faktorů.',
  'estimate_landing_page_b.section_three.item_3.title': 'Vysoká jistota odhadu',
  'estimate_landing_page_b.section_three.item_3.content':
    'Využíváme přesná data z katastru nemovitostí a realitních trendů 2023.',
  'estimate_landing_page_b.section_three.item_4.title':
    'Neustálý přehled o ceně',
  'estimate_landing_page_b.section_three.item_4.content':
    'Můžete sledovat vývoj ceny své nemovitosti, aktualizovaný vždy podle nových dat z katastru.',

  // section 4
  'estimate_landing_page_b.section_four.write_about_us.title': 'Napsali o nás:',

  // section 5
  'estimate_landing_page_b.section_five.title': 'Získejte ocenění online',
  'estimate_landing_page_b.section_five.item.title':
    'Zadáte údaje o vaší nemovitosti',
  'estimate_landing_page_b.section_five.item_2.title':
    'Umělá inteligence spočítá cenu',
  'estimate_landing_page_b.section_five.item_3.title':
    'Cenový odhad dostanete ihned',
  'estimate_landing_page_b.section_five.cta.want_estimate':
    'Spočítat odhad ZDARMA',

  // section 6
  'estimate_landing_page_b.section_six.title':
    'Co říkají majitelé, kteří si udělali online odhad?',
  'estimate_landing_page_b.section_six.item.fullname': 'Igor Š.',
  'estimate_landing_page_b.section_six.item.date': '1. února 2023',
  'estimate_landing_page_b.section_six.item.message':
    'Firmu hodnotím velice kladně. Mám díky ní dobrý přehled o odhadní ceně mého vlastního bydlení, jako i bytů okolo. A také mám představu o bytech které se v mém okolí prodávají nebo kupují. Reas.cz doporučuji.',
  'estimate_landing_page_b.section_six.item_2.fullname': 'Milož Z.',
  'estimate_landing_page_b.section_six.item_2.date': 'před 3 měsíci',
  'estimate_landing_page_b.section_six.item_2.message':
    'Pravděpodobně nejlepší odhad ceny nemovitosti na českém internetu! Vyplňujete i počet místností, stav bytu i kuchyně nebo koupelny. Ukáže vám to i prodané byty v okolí. Skvěle je i pravidelné informování o změnách cen. Doporučuji!',
  'estimate_landing_page_b.section_six.item_3.fullname': 'Olga N.',
  'estimate_landing_page_b.section_six.item_3.date': '26. září 2022',
  'estimate_landing_page_b.section_six.item_3.message':
    'Je zajímavé sledovat s ohledem na stávající okolnosti vývoj ceny mého bytu. Jsem už v pokročilém věku a pomáhá mi to promyslet podíly pro dědice. Děkuji.',
  'estimate_landing_page_b.section_six.item_4.fullname': 'Viktor P.',
  'estimate_landing_page_b.section_six.item_4.date': 'před 3 měsíci',
  'estimate_landing_page_b.section_six.item_4.message':
    'Krásná práce. Po zadání několika základních údajů jsem dostal informaci o ceně nemovitosti!',
  'estimate_landing_page_b.section_six.item_5.fullname': 'M.',
  'estimate_landing_page_b.section_six.item_5.date': '1. února 2023',
  'estimate_landing_page_b.section_six.item_5.message':
    'Skutečnost, že je mi pravidelně zasílán odhad ceny mého bytu je pro velkým přínosem a to i přesto, že jsem se zatím byt prodat nerozhodla.  Ale je to velmi příjemné, být stále "v obraze".',
  'estimate_landing_page_b.section_six.item_6.fullname': 'Ivan T.',
  'estimate_landing_page_b.section_six.item_6.date': 'před 4 měsíci',
  'estimate_landing_page_b.section_six.item_6.message':
    'Perfektní služba. Získate docela dobrou představu o hodnotě Vaší nemovitosti. Také chodí následné maily, když se něco v blízkosti adresy prodá. Nic se předem neplatí a netlačí na vás, že jim nemovitost musíte nutně svěřit k prodeji.',

  'estimate_landing_page_b.section_six.more': 'a více než 1000 dalších',

  // section 7
  'estimate_landing_page_b.section_seven.title':
    'Mějte přehled o ceně své nemovitosti',
  'estimate_landing_page_b.section_seven.subtitle':
    'Váš odhad bude aktualizovaný vždy podle nových dat z katastru',
  'estimate_landing_page_b.section_seven.cta.calc_estimate':
    'Spočítat odhad ZDARMA',
};
